export enum TenantUserRole {
  Owner = 'owner',
  Archivist = 'archivist',
  // Display-renamed to "Collaborator"; the wire value stays `guest` (backend contract).
  // Human-readable role labels live in messages/en.json under `users.roles.*`.
  Collaborator = 'guest',
}

/** Message-key union for `users.roles.*` — matches the role wire values. */
export type RoleKey = 'owner' | 'archivist' | 'guest';

export const tenantUserRoleOptions = [
  {
    label: 'Owner',
    value: 'owner',
  },
  {
    label: 'Archivist',
    value: 'archivist',
  },
];
